<template>
  <component
    :is="tag"
    v-bind="componentAttrs"
    v-on="$listeners"
    :class="classes"
  >
    <slot></slot>
  </component>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    tag: {
      type: String,
      default: 'button'
    },
    variant: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'sm'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes() {
      return [
        'btn',
        `btn-${this.variant}`,
        this.size ? `btn-${this.size}` : null,
        this.$attrs.class
      ].filter(Boolean);
    },

    componentAttrs() {
      const attrs = { ...this.$attrs };

      if (this.tag === 'button' && !attrs.type) {
        attrs.type = this.type;
      }

      return attrs;
    }
  }
};
</script>
